import BaseProxy from "../../base-proxy";

/**
 * @class GetPriceProxy
 * @description Class used for communicating GET requests with one off prices and subscriptions API.
 * @author Aldrev Ven Dayrit
 * @version 1.0
 * @since June 25, 2019
 */
export default class GetPriceProxy {
  /**
   * @async
   * @function execute
   * @param input - Input parameter instance.
   * @param {String} input.companySubscriptionIds - Company subscription ids.
   * @param {String} input.oneOffCodes - one off xero codes.
   * @param {String} input.authToken - Token used for issuing authenticated request.
   */
  async getPrice(input = {}) {
    let baseProxy = new BaseProxy();
    if (!input.authToken) {
      return {};
    }
    let backendUrl = await baseProxy.getBackendUrl();
    let subscriptionIds = input.companySubscriptionIds
      .map((subscriptionId) => `companySubscriptionIds=${subscriptionId}`)
      .join("&");
    let oneOffCodes = input.oneOffCodes.map((codes) => `oneOffCodes=${codes}`).join("&");
    let endpointUrl = `${backendUrl}/get-price?companyId=${input.id}&${subscriptionIds}&${oneOffCodes}`;

    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  }

  async getUpgradePrice(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/get-upgrade-price?companyId=${input.companyId}&addNewShareholderId=${input.addShareholderId}`;

    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  }
}
